<div class="take-on-container">
	<div class="container py-5">
		<app-page-title title="Refer a friend"></app-page-title>
			<router-outlet></router-outlet>
	</div>
</div>
